import { Capacitor } from '@capacitor/core';
import { initializeApp } from "firebase/app";
import { getAuth, initializeAuth, indexedDBLocalPersistence, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBqe7Y7X1gp2AOiwfCv4L9FcK0NSyaX-ak",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "yumii-1502.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "yumii-1502",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "yumii-1502.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "798074967750",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:798074967750:web:8fae4687a41a9ce4f969c7",
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://yumii-1502-default-rtdb.europe-west1.firebasedatabase.app"
};

const app = initializeApp(firebaseConfig);

export const auth = Capacitor.isNativePlatform()
    ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
    : getAuth(app);

export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
    })
});
export const rtdb = getDatabase(app);
export const storage = getStorage(app);
export const messaging = (typeof window !== 'undefined' && 'Notification' in window) ? getMessaging(app) : null;
export const functions = getFunctions(app, 'europe-west1');

// -- ADAPTIVE EMULATORS CONFIGURATION ("Met en local") --
// Default to PRODUCTION even on localhost. Set 'yumii_use_emulators' to 'true' in console to use local emulators.
const useEmulators = typeof window !== 'undefined' && localStorage.getItem('yumii_use_emulators') === 'true';

if (useEmulators && (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname.includes('192.168.')))) {
    // Detect host for different environments (Android Emulator uses 10.0.2.2)
    const isAndroid = Capacitor.getPlatform() === 'android';
    const host = isAndroid ? "10.0.2.2" : "127.0.0.1";
    
    console.log(`--- 🛰️ CONNECTING TO FIREBASE EMULATORS (Host: ${host}) ---`);
    
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8080);
    connectFunctionsEmulator(functions, host, 5001);
    connectStorageEmulator(storage, host, 9199);
    connectDatabaseEmulator(rtdb, host, 9000);
} else {
    console.log("--- 🌍 CONNECTED TO PRODUCTION (Default) ---");
}
